<template>
  <div class="step4">
    <Tips class="mt-2">
      <template v-slot:content>
        <div class="tips-content">
          亲爱的心动用户，为了保证你的账号安全，需要你提供<div style="display: initial;text-decoration: none;color: #ff6600;font-weight: 700;">心动账号(ID：{{user_id}})</div>实名验证时的信息以供注销核验，该信息仅作为本次验证使用。
        </div>
      </template>
    </Tips>
    <Input
      :valid="true"
      label="姓名："
      class="input mt-1"
      placeHolder="请输入姓名"
      :value="name"
      type="name"
      message="请输入真实姓名"
      ref="nameRef"
      :vaildStatusProps="nameStatus"
      :onInputChange="(value)=>{onInputChange(value,'name')}"
    />
    <Input
      :valid="true"
      label="身份证号："
      class="input mt-1"
      placeHolder="请输入身份证号"
      :value="id"
      type="id"
      ref="idRef"
      message="请输入正确的身份证号"
      :vaildStatusProps="idStatus"
      :onInputChange="(value)=>{onInputChange(value,'id')}"
    />
    <Input
      :valid="true"
      message="请输入正确的手机号"
      label="手机号码："
      class="input mt-1"
      type="intl"
      :setInstance="setIntlInstance"
      placeHolder="请输入手机号码"
      :value="phone"
      ref="phoneRef"
      :vaildStatusProps="phoneStatus"
      :onInputChange="(value)=>{onInputChange(value,'phone')}"
    />
    <Input
      :valid="true"
      label="手机验证码："
      class="input mt-1"
      message="请输入正确的6位短信验证码"
      placeHolder="请输入验证码"
      type="number"
      ref="validRef"
      :vaildStatusProps="validCodeStatus"
      :value="validCode"
      :onInputChange="(value)=>{onInputChange(value,'validCode')}"
    />
    <div id="captcha-element"></div>
    <div :class="[time < 60 ?  'message-container' : freeText === '重新发送'? 'message-container':'message-container-none' ]">
      <div class="text" v-if="time < 60 ? true : freeText === '重新发送' ? true : false">
        短信验证码正发送至您的手机，请收到验证码后30分钟内填写
      </div>
      <div @click="getMessageTip" v-show="time!==60 || phone.length === 0" class="mt-8" style="opacity:0.0;height:44px;"></div>
      <Button
        :style="freeText === '发送中....'? 'background:#ccc;color:#fff;' :  time === 60 ? '' : 'background:#ccc;color:#fff;' "
        :class="['message default-xd-button']"
        :text="time === 60 ? freeText : time+'s' "
        @click="handleGetSms"
      />
    </div>
    <Button :disabled="validCode.length === 0" @click="goToNextStep" class="default-xd-button mt-8 mb-8" text="验证" />

    <Diglog
      :show="isShowDialog"
      :inLineStyle="queryIDContentStyle"
      class="dialog"
    >
      <template v-slot:content>
        <div class="query-id-content">
          <div :style="queryIDContentTitle">如何查询心动 ID？</div>
          <RichText>
            <template v-slot:content>
              <QueryXdId />
            </template>
          </RichText>
          <div
            style="border-top: 1px solid #8a8a8a1f"
            class="i-know-container w-full flex justify-center mb-5"
          >
            <Button
              @click="toggleDialog"
              class="i-know default-xd-button w-11/12 mt-5"
              text="我知道了"
            />
          </div>
        </div>
      </template>
    </Diglog>
  </div>
</template>

<script>
import Input from '../../components/input'
import Button from '../../components/button'
import Diglog from '../../components/dialog'
import RichText from '../../components/richtext.vue'
import QueryXdId from './modal/query-xd-id'
import Tips from '../../components/tips'
import Api from '../../common/api'
import { Toast } from 'vant'
const env = process.env.NODE_ENV
const baseUrl = env === 'development' ? '/api/user_logout' : 'https://api.xd.com/api/user_logout'
export default {
  props: {
    nextStep: {
      type: Function,
      default: () => {}
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowCap: false,
      placeHolder: '请输入你的心动 ID',
      name: '',
      id: '',
      freeText: '免费获取',
      validCode: '',
      phone: '',
      value: '',
      user_id: '',
      timeOut: [],
      isShowDialog: false,
      nameStatus: true,
      idStatus: true,
      phoneStatus: true,
      validCodeStatus: true,
      queryIDContentStyle: {
        width: '89%',
        height: '90%',
        border: '1px solid #E6E6E6',
        'border-radius': '5px'
      },
      intlInstance: null,
      queryIDContentTitle: {
        height: '58px',
        'border-bottom': '1px solid #8a8a8a1f',
        'text-align': 'center',
        'font-family': 'PingFang SC',
        'font-style': 'normal',
        'font-weight': '500',
        'font-size': '16px',
        'line-height': '58px',
        /* identical to box height, or 162% */
        'letter-spacing': '4.93506e-09px',
        color: '#333333'
      },
      time: 60,
      captchaVerifyParam: '',
      captchaInstance: null,
      pendingSend: false
    }
  },
  components: {
    Input,
    Button,
    Diglog,
    RichText,
    QueryXdId,
    Tips
  },
  mounted () {
    if (!window.cancellationAgreement) {
      this.$router.push({ name: 'Home', hash: '#step1', params: { index: 2 } })
    }
    if (window.userData) {
      this.name = window.userData.realname
      this.id = window.userData.realid
      this.phone = window.userData.mobile
    }
    this.user_id = window.user_id || ''

    this.initCaptcha()
  },
  methods: {
    getMessageTip () {
      // if (this.phone.length === 0) {
      //   Toast('您必须填写手机号！')
      // }
      this.triggerStatus()
    },
    clickHook (event) {
      if (this.time === 60) {
      } else {
        // event.preventDefault()
      }
    },
    countDown () {
      this.time--
      if (this.time > 0) {
        const time = setTimeout(() => {
          this.countDown()
        }, 1000)
        this.timeOut.push(time)
      }
      if (this.time === 0) {
        this.time = 60
        this.isShowCap = false
        this.clearTimeOut()
        this.freeText = '重新发送'
      }
    },
    clearTimeOut () {
      this.timeOut.forEach((item) => {
        window.clearTimeout(item)
      })
    },
    setIntlInstance (instance) {
      this.intlInstance = instance
    },
    getVerifyCode () {
      this.isShowCap = true
    },
    triggerStatus () {
      const { phone, name, id } = this
      let result = true
      // if (validCode.length === 0) {
      //   this.validCodeStatus = false
      // }
      if (phone.length === 0) {
        this.phoneStatus = false
        result = false
      }
      if (name.length === 0) {
        this.nameStatus = false
        result = false
      }
      if (id.length === 0) {
        this.idStatus = false
        result = false
      }
      if (!this.$refs.nameRef.validStatus) {
        result = false
      }
      if (!this.$refs.phoneRef.validStatus) {
        result = false
      }
      if (!this.$refs.idRef.validStatus) {
        result = false
      }
      if (!this.captchaVerifyParam) {
        result = false
      }
      return result
    },
    handleGetSms () {
      if (this.triggerStatus()) {
        this.pendingSend = false
        this.getSms()
      } else if (!this.captchaVerifyParam) {
        this.pendingSend = true
      }
    },
    getSms () {
      const formData = new FormData()
      const result = this.intlInstance.xdInputCheck()
      // eslint-disable-next-line camelcase
      const countryCode = this.intlInstance.intlTelInput('getSelectedCountryData').dialCode
      const data = {
        mark: 'xd',
        user_id: window.user_id,
        captcha_verify_param: this.captchaVerifyParam,
        country_code: Number(countryCode),
        mobile: Number(result.value),
        realname: this.name,
        realid: this.id
      }
      for (const i in data) {
        formData.append(i, data[i])
      }
      this.requesting = true
      this.freeText = '发送中....'
      fetch(`${baseUrl}/sendCode`, {
        headers: {
        },
        body: formData,
        method: 'POST',
        mode: 'cors'
      }).then((res) => {
        this.requesting = false
        res.json().then((data) => {
          if (data.result === 'success') {
            this.countDown()
          }
          if (data.result !== 'success') {
            Toast({
              message: data.msg,
              icon: 'info-o',
              className: 'xd-toast',
              duration: 3000
            })
            this.time = 60
            this.clearTimeOut()
            this.freeText = '免费获取'
          }
          this.resetCaptcha()
        })
      }).catch(() => {
        this.requesting = false
        this.freeText = '免费获取'
        this.resetCaptcha()
      })
    },
    resetCaptcha () {
      this.captchaVerifyParam = ''
      this.pendingSend = false
      this.initCaptcha()
    },
    initCaptcha () {
      if (typeof window === 'undefined') return
      if (typeof window.initAliyunCaptcha !== 'function') return
      window.initAliyunCaptcha({
        SceneId: 'hrhi4jcp',
        mode: 'embed',
        element: '#captcha-element',
        button: '#captcha-element',
        success: (param) => {
          this.captchaVerifyParam = param
          if (this.pendingSend) {
            this.pendingSend = false
            if (this.triggerStatus()) {
              this.getSms()
            }
          }
        },
        fail: () => {
          this.captchaVerifyParam = ''
        },
        getInstance: (instance) => {
          this.captchaInstance = instance
        },
        slideStyle: {
          width: document.getElementById('captcha-element') ? document.getElementById('captcha-element').offsetWidth : 320,
          height: 40
        }
      })
    },
    toggleDialog () {
      this.isShowDialog = !this.isShowDialog
    },
    goToNextStep () {
      if (!this.triggerStatus()) {
        return
      }
      this.validCodeStatus = true
      const data = {
        user_id: window.user_id,
        realname: this.name,
        realid: this.id,
        country_code: this.intlInstance.intlTelInput('getSelectedCountryData').dialCode,
        mobile: this.phone,
        sms_code: this.validCode
      }
      Api.checkReal(data).then((res) => {
        if (res.code === 1) {
          this.$emit('nextStep')
          window.userData = data
          window.gameList = res.data
        } else if (res.code === -2) {
          this.validCodeStatus = false
          this.resetCaptcha()
        } else {
          Toast({
            message: '身份信息不一致',
            icon: 'info-o',
            className: 'xd-toast',
            duration: 3000
          })
          window.userData = null
          this.resetCaptcha()
        }
      }).catch(err => {
        console.log(err)
        window.userData = null
        this.resetCaptcha()
      })
      // this.$emit('nextStep')
    },
    onInputChange (e, type) {
      switch (type) {
        case 'name':
          this.name = e
          break
        case 'id':
          this.id = e
          break
        case 'phone':
          this.phone = e
          break
        case 'validCode':
          this.validCode = e
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
.step4 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .message-container{
    width: 100%;
    background: #F9F9FB;
    border: 1px solid #EDF1F1;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 11px;
    display: grid;
    margin-top: 16px;
    .text{
      transition: 1s ease-in-out;
    }
    button{
      width: 100%;
    }
  }
  .message-container-none{
    transition: 1s ease-in-out;
    // display: grid;
    .text{
      transition: 1s ease-in-out;
    }
    button{
      width: 100%;
    }
  }
  .message {
    transition: 1s ease-in-out;
    background: #f1f9fe;
    border: 1px solid #c9dae9;
    box-sizing: border-box;
    border-radius: 5px;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin-top: -44px;
    button{
      width: 100%;
    }
    /* identical to box height, or 150% */
    .text{
      transition: 1s ease-in-out;
    }
    text-align: center;
    letter-spacing: -0.2px;

    color: #6D99C3;
  }
  .vaild {
    background: #cccccc;
    border-radius: 5px;
    // border: 0px !important;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */

    text-align: center;
    letter-spacing: 2.87879e-09px;

    color: #FFFFFF;
  }
  .input {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
    margin-top: 8px;
  }

  #captcha-element {
    position: relative;
    width: 100%;
    min-height: 40px;
    margin: 20px auto;
  }
}

</style>
